import { Icon, IconProps } from "@chakra-ui/icon";

function EatIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_3497_29200)">
				<path
					d="M3.03194 12.1781C2.9571 12.6838 3.0143 13.1998 3.19816 13.6781C3.38206 14.1563 3.68663 14.5813 4.08357 14.9134C4.39991 15.17 4.76734 15.3594 5.16253 15.4696C5.61647 15.5947 6.0936 15.6169 6.55766 15.5347C7.02174 15.4525 7.46061 15.268 7.84095 14.9952C8.22131 14.7224 8.53314 14.3684 8.75285 13.9601C8.97256 13.5518 9.09439 13.0999 9.10903 12.6387C9.12778 12.1507 9.27337 11.6754 9.53203 11.2577C9.79074 10.84 10.154 10.4938 10.5874 10.2516C11.468 9.75001 12.1649 8.99009 12.5796 8.07946C12.9943 7.16888 13.1057 6.1537 12.8981 5.17771C12.6905 4.20172 12.1744 3.31433 11.4228 2.64121C10.6712 1.9681 9.72228 1.54334 8.71033 1.42708C7.937 1.37602 7.16281 1.51334 6.45705 1.82683C5.58607 2.20275 4.8877 2.88013 4.49594 3.72901C4.10416 4.57787 4.04659 5.53836 4.33428 6.42622C4.61527 7.31209 4.55571 8.26788 4.1668 9.11379L3.34563 10.9009C3.21334 11.1834 3.12508 11.4838 3.08379 11.7919L3.03194 12.1781Z"
					stroke="currentColor"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.04121 4.8361C7.54546 4.78928 7.05141 4.94126 6.66773 5.2587C6.28404 5.5761 6.04217 6.0329 5.99529 6.52865C5.99415 6.54019 5.9932 6.55155 5.99245 6.56309C5.985 6.74585 6.05036 6.92408 6.17415 7.05871C6.29797 7.19333 6.47011 7.27334 6.65284 7.28122H6.65871C7.19172 7.32929 7.4446 7.83562 7.38213 8.3266C7.29336 9.02315 6.64545 9.28057 6.16337 9.68411C5.85181 9.91621 5.64008 10.258 5.5711 10.6404C5.56494 10.7023 5.56993 10.7649 5.58587 10.8251C5.78688 11.6185 6.34432 11.7881 6.80029 11.6452C6.98942 11.5852 7.15447 11.4664 7.27142 11.3061C7.3884 11.1458 7.45118 10.9524 7.45065 10.7539C7.44857 10.2978 7.82921 10.1282 8.16537 9.92317C8.83451 9.50069 9.33427 8.85686 9.57758 8.10382C9.81475 7.39573 9.90523 6.43704 9.50944 5.76944C9.35527 5.50943 9.14199 5.28943 8.88689 5.12727C8.63179 4.96511 8.34206 4.86535 8.04121 4.8361Z"
					fill="currentColor"
					fillOpacity="0.12"
				/>
				<path
					d="M8.04121 4.8361C7.54546 4.78928 7.05141 4.94126 6.66773 5.2587C6.28404 5.5761 6.04217 6.0329 5.99529 6.52865C5.99415 6.54019 5.9932 6.55155 5.99245 6.56309C5.985 6.74585 6.05036 6.92408 6.17415 7.05871C6.29797 7.19333 6.47011 7.27334 6.65284 7.28122H6.65871C7.19172 7.32929 7.4446 7.83562 7.38213 8.3266C7.29336 9.02315 6.64545 9.28057 6.16337 9.68411C5.85181 9.91621 5.64008 10.258 5.5711 10.6404C5.56494 10.7023 5.56993 10.7649 5.58587 10.8251C5.78688 11.6185 6.34432 11.7881 6.80029 11.6452C6.98942 11.5852 7.15447 11.4664 7.27142 11.3061C7.3884 11.1458 7.45118 10.9524 7.45065 10.7539C7.44857 10.2978 7.82921 10.1282 8.16537 9.92317C8.83451 9.50069 9.33427 8.85686 9.57758 8.10382C9.81475 7.39573 9.90523 6.43704 9.50944 5.76944C9.35527 5.50943 9.14199 5.28943 8.88689 5.12727C8.63179 4.96511 8.34206 4.86535 8.04121 4.8361Z"
					stroke="currentColor"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3497_29200">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</Icon>
	);
}

export default EatIcon;
